<template>
  <div>
    <div class="list">
      <el-descriptions class="margin-top" :column="1" size="small" border>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            用户名
          </template>
          {{ userInfo.name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-mobile-phone"></i>
            手机号
          </template>
          {{ userInfo.phone }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-star-off"></i>
            用户类型
          </template>
          {{ userInfo.type | filterType }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-chat-round"></i>
            微信绑定
          </template>
          <el-tag size="mini" :type="userInfo.open_id ? 'success' : 'warning'">
            {{ userInfo.open_id ? "已绑定" : "未绑定" }}
          </el-tag>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>

<script>
import EnumerationType from "@/api/constant/EnumerationType";
import { mapGetters } from "vuex";
export default {
  filters: {
    // 管理员类型
    filterType(id) {
      // find:找出满足条件的项，如果找不到返回undefined,找到了返回相应项数据
      const result = EnumerationType.type.find((item) => item.id === id);
      return result ? result.value : "";
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
};
</script>

<style scoped lang="scss"></style>
